import {FC, Fragment} from 'react'
import {Row} from 'react-table'
import { ApplicationReview } from '../../../../../core/applications'
import { PropsWithNotes, TableNotesRow } from '../../../../../../components/table'
import clsx from 'clsx'

type Props = {
  row: Row<PropsWithNotes<ApplicationReview>>
}

const CustomRow: FC<Props> = ({row}) => {
 
  const { showNotes, notes } =  row.original;
  const has_notes = showNotes && notes && notes.length > 0;

  const { key: rowKey, ...restRowProps } = row.getRowProps();

  return (
  <Fragment key={`Frag${rowKey}`}>
  <tr key={rowKey} {...restRowProps}>
    {row.cells.map((cell, cidx) => {
      const { key: cellKey, ...restCellProps } = cell.getCellProps();
      return (
        <td
          key={cellKey}
          {...restCellProps}          
          rowSpan={(cidx < 2 && has_notes) ? 2 : 1}
          className={clsx('fs-7',                    
            {'align-top pt-4' : cidx < 2},              
          )}                
        >
          {cell.render('Cell')}
        </td>
      )
    })}
  </tr>
  { has_notes && 
    <TableNotesRow colSpan={4} notes={notes} />    
  }
  </Fragment>
  )

}
  
export {CustomRow}
